export default __webpack_public_path__ + "static/media/quality.e2a83e2a.png";